/*
 * @Description:
 * @Date: 2025-05-19 18:04:00
 */
import AccountMain from '../views/account-main.vue';
import AccountInfo from '../views/account-info.vue';
import router from '@/router';
import appStore from '@/store';

export const route = [
  // 服务商
  {
    path: '/main/a/account/list',
    name: 'a-account-list',
    meta: {
      title: '账户管理',
      functionCode: 2
    },
    component: AccountMain
  },
  // 供应商
  {
    path: '/main/s/account/list',
    name: 's-account-list',
    meta: {
      title: '账户管理',
      functionCode: 3
    },
    component: AccountMain
  },
  {
    path: '/main/dbgys/account/list',
    name: 'dbgys-account-list',
    meta: {
      title: '账户管理',
      functionCode: 8
    },
    component: AccountMain
  },
  {
    path: '/main/a/account/info',
    name: 'a-account-info',
    meta: {
      title: '账户详情',
      parentPath: '/main/a/account/list'
    },
    component: AccountInfo
  },
  {
    path: '/main/s/account/info',
    name: 's-account-info',
    meta: {
      title: '账户详情',
      parentPath: '/main/s/account/list'
    },
    component: AccountInfo
  },
  {
    path: '/main/dbgys/account/info',
    name: 'dbgys-account-info',
    meta: {
      title: '账户详情',
      parentPath: '/main/dbgys/account/list'
    },
    component: AccountInfo
  }
];
/**
 * @description: 富友账户详情
 */
export const pushfyDetail = (query: { payPassagewayCode: string }) => {
  const { info } = appStore.useUserStoreSetup;
  const detailName = {
    2: 'a-account-info',
    3: 's-account-info',
    8: 'dbgys-account-info'
  };
  router.push({
    name: detailName[info.functionCode],
    query
  });
};
